import create from 'zustand'
import api from '../utils/api'
const url = '/blacklisted'
const useBlacklistedStore = create((set) => ({
  blacklisted: [],
  isLoading: false,
  error: null,
  count: 0,

  fetchBlacklisted: async (params) => {
    set({ isLoading: true, error: null })
    try {
      const response = await api.get(url, {
        params,
        includeToken: true,
      })
      const data = await response.data
      set({ blacklisted: data.data, count: data.count, isLoading: false })
    } catch (error) {
      set({ error: error.message, isLoading: false })
    }
  },

  createBlacklistedItem: async (item) => {
    set({ isLoading: true, error: null })
    try {
      const response = await api.post(url, { ...item })

      set((state) => ({
        // blacklisted: [...state.blacklisted, response.data],
        isLoading: false,
      }))
      useBlacklistedStore.getState().fetchBlacklisted()
    } catch (error) {
      set({ error: error.message, isLoading: false })
    }
  },

  updateBlacklistedItem: async (item) => {
    set({ isLoading: true, error: null })
    try {
      const response = await api.put(`${url}/${item.id}`, { ...item })

      set((state) => ({
        // blacklisted: [...state.blacklisted, response.data],
        isLoading: false,
      }))
    } catch (error) {
      set({ error: error.message, isLoading: false })
    }
  },

  deleteBlacklistedItem: async (id) => {
    set({ isLoading: true, error: null })
    try {
      await api.remove(`${url}/${id}`)
      set((state) => ({
        blacklisted: state.blacklisted.filter((item) => item.id !== id),
        isLoading: false,
      }))
    } catch (error) {
      set({ error: error.message, isLoading: false })
    }
  },
}))

export default useBlacklistedStore
